import React from 'react';
import { financialOverview, systemHealth } from '../utils/mockData';
import { BellIcon, ShieldCheckIcon, ActivityIcon } from 'lucide-react';
const FinancialBar = ({
  filters
}) => {
  return <div className="w-full bg-slate-800 rounded-lg p-4 flex justify-between" data-id="element-116">
      {/* Financial Overview */}
      <div className="flex gap-6" data-id="element-117">
        <div data-id="element-118">
          <h3 className="text-sm font-semibold mb-2" data-id="element-119">Financial Overview</h3>
          <div className="grid grid-cols-2 gap-x-8 gap-y-3 text-xs" data-id="element-120">
            <div data-id="element-121">
              <div className="flex justify-between mb-1" data-id="element-122">
                <span data-id="element-123">Revenue (YTD)</span>
                <span data-id="element-124">
                  ETB {(financialOverview.actualRevenue / 1000000).toFixed(0)}M
                  /{(financialOverview.budgetedRevenue / 1000000).toFixed(0)}M
                </span>
              </div>
              <div className="w-48 bg-slate-600 rounded-full h-1.5" data-id="element-125">
                <div className="h-1.5 rounded-full bg-blue-500" style={{
                width: `${financialOverview.actualRevenue / financialOverview.budgetedRevenue * 100}%`
              }} data-id="element-126"></div>
              </div>
            </div>
            <div data-id="element-127">
              <div className="flex justify-between mb-1" data-id="element-128">
                <span data-id="element-129">Expenditure (YTD)</span>
                <span data-id="element-130">
                  ETB{' '}
                  {(financialOverview.actualExpenditure / 1000000).toFixed(0)}M
                  /
                  {(financialOverview.budgetedExpenditure / 1000000).toFixed(0)}
                  M
                </span>
              </div>
              <div className="w-48 bg-slate-600 rounded-full h-1.5" data-id="element-131">
                <div className="h-1.5 rounded-full bg-green-500" style={{
                width: `${financialOverview.actualExpenditure / financialOverview.budgetedExpenditure * 100}%`
              }} data-id="element-132"></div>
              </div>
            </div>
          </div>
        </div>
        <div data-id="element-133">
          <h3 className="text-sm font-semibold mb-2" data-id="element-134">Top Revenue Services</h3>
          <div className="flex gap-3 text-xs" data-id="element-135">
            {financialOverview.topRevenueServices.slice(0, 3).map((service, index) => <div key={index} className="bg-slate-700 p-2 rounded-lg" data-id="element-136">
                  <div className="font-semibold" data-id="element-137">{service.name}</div>
                  <div className="text-blue-400" data-id="element-138">
                    ETB {(service.revenue / 1000000).toFixed(1)}M
                  </div>
                </div>)}
          </div>
        </div>
      </div>
      {/* System Health */}
      <div className="flex gap-8" data-id="element-139">
        <div className="flex items-center gap-6" data-id="element-140">
          <div className="flex flex-col items-center" data-id="element-141">
            <div className="text-sm mb-1" data-id="element-142">System Uptime</div>
            <div className={`text-lg font-bold ${systemHealth.uptime > 0.999 ? 'text-green-400' : 'text-yellow-400'}`} data-id="element-143">
              {(systemHealth.uptime * 100).toFixed(2)}%
            </div>
          </div>
          <div className="flex flex-col items-center" data-id="element-144">
            <div className="text-sm mb-1" data-id="element-145">Security Index</div>
            <div className={`text-lg font-bold ${systemHealth.securityIndex > 0.9 ? 'text-green-400' : systemHealth.securityIndex > 0.8 ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-146">
              {(systemHealth.securityIndex * 100).toFixed(0)}%
            </div>
          </div>
        </div>
        <div className="flex gap-3 items-center" data-id="element-147">
          <div className="flex items-center gap-1" data-id="element-148">
            <ActivityIcon size={16} className="text-green-400" data-id="element-149" />
            <span className="text-xs" data-id="element-150">
              Activity: {systemHealth.auditLogActivity}
            </span>
          </div>
          <div className="relative" data-id="element-151">
            <BellIcon size={20} className="text-slate-300" data-id="element-152" />
            <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full" data-id="element-153"></span>
          </div>
          <div className="bg-slate-700 px-3 py-1 rounded-full text-xs flex items-center gap-1" data-id="element-154">
            <ShieldCheckIcon size={12} className="text-green-400" data-id="element-155" />
            <span data-id="element-156">Secure</span>
          </div>
        </div>
      </div>
    </div>;
};
export default FinancialBar;